import JSX, {Component, h} from 'preact'
import SearchBox from "../../../preact-components/search-box/SearchBox";

type Props = {
  items?: any[],
  placeholder?: string,
  children: JSX.Element
}

type State = { value: string }

class SearchableFilterSelector extends Component<Props, State> {
  constructor () {
    super()
    this.state = { value: '' }
  }

  render ({ items, placeholder, children } : Props, { value }: State) {
    const filteredItems = items && items.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
    return <div class='overview__filters-box-content'>
      <SearchBox
          isModerationOverview
          placeholder={placeholder}
          value={value}
          onSubmit={() => {}}
          onInput={(e) => this.setState({value: (e.target as HTMLInputElement).value})}
          onClear={() => this.setState({ value: '' })}
      />
      { filteredItems && filteredItems.length === 0 && <div class='overview__filters-box-content-no-results'>No results found</div> }
      { children[0]({ items: filteredItems, value }) }
    </div>
  }
}

export default SearchableFilterSelector
